import { useFeed } from './useFeed';
import { subscribeRecentItems } from '../data/items';

const NO_ITEMS = [];

/**
 * Live daily-board items for the last `daysBack` days. `truncated`: a query hit its
 * cap, so the oldest day loaded may be partial (History fetches around it). `error`: the
 * feed is down — the last items stay on screen and it re-opens by itself (useFeed).
 */
export function useRecentItems(daysBack) {
  const { data, meta, loading, error } = useFeed(
    `items:${daysBack}`,
    (onData, onError) => subscribeRecentItems(daysBack, onData, onError),
    { initial: NO_ITEMS },
  );
  return { items: data, truncated: !!(meta && meta.truncated), loading, error };
}
